import FaimLocale from "faim/dist/locale/zh-cn.mjs";

export default {
  locale: FaimLocale.FaFormDialog,
}
